module.exports = __webpack_public_path__ + "img/Jump Casting46.bd12bdd7.jpg";